export default "__VITE_ASSET__CNHYGAV9__"